
/**
 * drehen vom mausrad simuliert klicken auf up-/down buttons
 */

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2MouseWheelUpDown {
    private btn_up: MovieClip;
    private btn_down: MovieClip;
    private mouseArea: Container;
    private lastScroll: number = 0;

    constructor() {
    }

    /**
     * @param btn_up		mausraddreh erzeugt darauf button.click
     * @param btn_down		und scrollfläche, auf der das mausraddrehen aktiv ist
     * @param mouseArea		eigentliche scrollfläche. wenn null, dann sind nur die buttons die scrollfläche
     */
    public init(btn_up: MovieClip, btn_down: MovieClip, mouseArea: Container = null): void {
        this.destroy();
        this.btn_up = btn_up;
        this.btn_down = btn_down;
        this.mouseArea = mouseArea;
    }

    /**
     * alles deinstallieren
     */
    public destroy(): void {
        // listener entfernen
        this.deactivateMouseWheel();
        // referenzen löschen
        this.btn_up = null;
        this.btn_down = null;
        this.mouseArea = null;
    }

    /**
     * listener installieren
     */
    public activateMouseWheel(): void {
        if (this.btn_up) {
            this.btn_up.addEventListener(MouseEvent.MOUSE_WHEEL, this.bindFunction(this.onMouseWheel));
        }
        if (this.btn_down) {
            this.btn_down.addEventListener(MouseEvent.MOUSE_WHEEL, this.bindFunction(this.onMouseWheel));
        }
        if (this.mouseArea) {
            this.mouseArea.addEventListener(MouseEvent.MOUSE_WHEEL, this.bindFunction(this.onMouseWheel));
        }
    }

    /**
     * listener deinstallieren
     */
    public deactivateMouseWheel(): void {
        if (this.btn_up) {
            this.btn_up.removeEventListener(MouseEvent.MOUSE_WHEEL, this.bindFunction(this.onMouseWheel));
        }
        if (this.btn_down) {
            this.btn_down.removeEventListener(MouseEvent.MOUSE_WHEEL, this.bindFunction(this.onMouseWheel));
        }
        if (this.mouseArea) {
            this.mouseArea.parent.removeEventListener(MouseEvent.MOUSE_WHEEL, this.bindFunction(this.onMouseWheel));
        }
    }

    /**
     * mousewheel wie up/down- buttonklick
     * @param event
     */
    private onMouseWheel(event: MouseEvent): void {
        let now = Date.now();
        if (now - this.lastScroll > 50) {
            this.lastScroll = now;
        } else {
            return;
        }

        if (event.delta < 0) {
            this.btn_up.dispatchEvent(new MouseEvent(MouseEvent.CLICK, true));
        }
        else if (event.delta > 0) {
            this.btn_down.dispatchEvent(new MouseEvent(MouseEvent.CLICK, true));
        }
    }

}
